import { useLocale } from "../i18n";
export function Brand({ home = "/" }: { home?: string }) {
  const { w } = useLocale();
  return (
    <a className="brand" href={home} aria-label={w("مزن — العودة إلى الصفحة الرئيسية", "MZN — Go to home")}>
      <span className="brand-icon">
        <img src="/brand/mzn-mark.svg" alt="" />
      </span>
      <div>
        <strong>{w("مَزَن", "MZN")}</strong>
        <span>{w("مركز الإدارة", "ADMIN WORKSPACE")}</span>
      </div>
    </a>
  );
}
export function LanguageButton() {
  const { lang, setLang } = useLocale();
  return (
    <button
      className="language-button"
      onClick={() => setLang(lang === "ar" ? "en" : "ar")}
      lang={lang === "ar" ? "en" : "ar"}
    >
      {lang === "ar" ? "English" : "العربية"} <span aria-hidden="true">◎</span>
    </button>
  );
}
